<template>
  <div class="productlist">
    <div class="kong">
      <Header></Header>
    </div>
    <div class="top"></div>
    <div class="wrap_title">
      <div class="title_box">
        <div class="title">
          <a class="no" href="/">{{ $t("system.home.menu.home") }}</a>
          <template v-for="(item, index) in breadcrumbs" :key="index">
            <text class="separator">></text>
            <a
              :class="{ current: index === breadcrumbs.length - 1 }"
              @click="handleBreadcrumbClick(index)"
              :style="{
                cursor:
                  index === breadcrumbs.length - 1 ? 'default' : 'pointer',
              }"
            >
              {{ item.title }}
            </a>
          </template>
        </div>
      </div>
    </div>
    <!-- 产品动态列表 -->
    <div class="content">
      <div class="products">
        <div
          v-for="product in products"
          :key="product.id"
          class="product-item"
          @click="goToProduct(product)"
        >
          <h1>{{ getTranslatedText(product.translations, "name") }}</h1>
          <div class="product-oe">
            <span>{{ product.oe }}</span>
          </div>
          <img
            :src="product.url"
            :alt="getTranslatedText(product.translations, 'name')"
          />
        </div>
      </div>
      <!-- 分页器 -->
      <div class="pagination-container">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="totalRecords"
          :current-page.sync="currentPage"
          @current-change="handlePageChange"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"></Navbar>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useProductStore } from "@/stores/product";
import Header from "./Header.vue";
import Lianjie from "./Lianjie.vue";
import Scroll from "./Scroll.vue";
import Navbar from "./Navbar.vue";
import axios from "./../../../utils/axios";
import { useBreadcrumbStore } from "@/stores/breadcrumb";

const breadcrumbStore = useBreadcrumbStore();
const route = useRoute();
const router = useRouter();
const productStore = useProductStore();
const products = ref([]);

const breadcrumbs = ref([]);
// 初始化分页参数
const currentPage = ref(1);
const pageSize = ref(6);
const totalRecords = ref(0);
const { locale, t: $t } = useI18n();
const getTranslatedText = (
  translations: any,
  key: string,
  defaultText: string = ""
) => {
  if (!translations) return defaultText;
  return (
    translations[locale.value]?.[key] ||
    translations["zh-cn"]?.[key] ||
    translations["en"]?.[key] ||
    defaultText
  );
};
// 更新面包屑方法
const updateBreadcrumbs = () => {
  const crumbs = breadcrumbStore.breadcrumbs;
  if (crumbs && crumbs.length > 0) {
    breadcrumbs.value = crumbs.map((item) => ({
      title: item.translations
        ? getTranslatedText(item.translations, "cname")
        : item.title,
    }));
  } else {
    breadcrumbs.value = [{ title: $t("system.productList") }];
  }
};
// 根据查询参数获取产品列表
const fetchProductList = async (params: any) => {
  console.log(params);

  try {
    const response = await axios.get("/framework/product/list", {
      params: {
        cid: params.cid,
        page: currentPage.value,
        limit: pageSize.value,
      },
    });
    products.value = response.records;
    totalRecords.value = response.total;
  } catch (error) {
    console.error("获取产品列表失败：", error.message);
  }
};

// 组件挂载时获取查询参数并获取产品列表
onMounted(() => {
  const queryParams = route.query;
  fetchProductList(queryParams);
  updateBreadcrumbs();
});
// 监听语言变化时更新面包屑
watch(locale, () => {
  updateBreadcrumbs();
});

// 监听查询参数的变化
watch(
  route,
  (newRoute) => {
    const queryParams = newRoute.query;
    fetchProductList(queryParams);
    // 添加面包屑更新
    updateBreadcrumbs();
  },
  { deep: true }
);

// 分页更改时的处理函数
const handlePageChange = (newPage: number) => {
  currentPage.value = newPage;
  router.push({
    path: route.path,
    query: {
      ...route.query,
      page: newPage,
    },
  });
};

const goToProduct = (product: any) => {
  localStorage.setItem("productBreadcrumbs", JSON.stringify(breadcrumbs.value));

  // 保存到 store
  breadcrumbStore.setBreadcrumbs(breadcrumbs.value);
  router.push({ path: `/home/product/${product.id}` });
};
const handleBreadcrumbClick = async (index: number) => {
  if (index === breadcrumbs.value.length - 1) return;

  const { systemId, menuId, parentId, systemLayout } = route.query;

  if (index === 0) {
    router.push({
      path: "/home/product-system",
      query: {
        ...(systemId ? { systemId, parentId } : { menuId, parentId }),
        systemLayout,
      },
    });
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.kong {
  max-width: 1200px;
  height: 120px;
}

.filter {
  width: 100%;
  padding-left: 20px;
  font-size: 18px;
  margin-bottom: 20px;
}

.top {
  width: 100%;
  height: 553px;
  position: relative;
  background-image: url("./../../../assets/imgs/prodList_backgronud.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100% 100%;
}

.content {
  width: 100%;
  padding-bottom: 60px;
}

.products {
  max-width: 1230px;
  margin: 0 auto;
  height: auto;
  padding: 30px 5px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 30px;
}

.product-item {
  display: flex;
  text-align: center;
  flex-direction: column;
  width: calc((100% - 60px) / 3);
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease; /* 添加过渡效果 */
  overflow: hidden;
  padding: 30px 0;
  margin-bottom: 30px;
}

.product-item:hover {
  transform: translateY(-10px); /* 向上浮动 */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* 增强阴影 */
}

.product-item img {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding-bottom: 10px;
  border-radius: 10px;
  transition: transform 0.3s ease;
}
.product-item h1 {
  color: #004080;
  margin: 0;
  transition: color 0.3s ease; /* 标题颜色过渡 */
}

.product-item:hover h1 {
  color: #004080; /* 悬浮时标题颜色加深 */
}

.product-item span {
  font-size: 18px;
  color: #666;
  margin: 10px 0;
  padding: 0;
}
.wrap_title {
  padding: 30px 0;
  width: 100%;
  color: #3e3a39;
  font-size: 14px;
  height: 26px;
}

.title_box {
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
  box-sizing: border-box;
}
.title {
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0 -8px;
}
.title a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}
.separator {
  color: #696b71;
}
.product-oe {
  margin: 20px 0;
}
</style>
